var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H3C2.17275 3 1.5 3.67275 1.5 4.5V13.5C1.5 14.3273 2.17275 15 3 15H15C15.8273 15 16.5 14.3273 16.5 13.5V4.5C16.5 3.67275 15.8273 3 15 3ZM15 4.5V4.88325L9 9.5505L3 4.884V4.5H15ZM3 13.5V6.783L8.5395 11.0917C8.67083 11.1949 8.833 11.251 9 11.251C9.167 11.251 9.32917 11.1949 9.4605 11.0917L15 6.783L15.0015 13.5H3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8c77384f05ac15ec287d10921c32a04f.svg";
export { ForwardRef as ReactComponent };